<template>
    <div style="background-color: #fff;padding: 30px " >
        <div>
            <div class="topBox">
                <div class="startBox" @click="toInitiate">
                    <p>发起立案</p>
                    <span>填写证据清单</span>
                </div>
                <div class="importBox" @click="skipCase">
                    <p>导入案件</p>
                    <span>跳转案件管理</span>
                </div>
            </div>
        </div>
<!--        数据展示-->
<!--        <div class="displayBox">-->
<!--&lt;!&ndash;            左边&ndash;&gt;-->
<!--            <div class="leftBox">-->
<!--                <div class="auditBox">-->
<!--                    <div class="auditBoxLeft">-->
<!--                        <p>待审核案件:</p>-->
<!--                        <span>0 件</span>-->
<!--                    </div>-->
<!--                    <div class="auditBoxRight">-->
<!--                        <p>被申请案件:</p>-->
<!--                        <span>0 件</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="approved">-->
<!--                    <div class="approvedLeft">-->
<!--                        <p>已审核通过案件:</p>-->
<!--                        <span>0 件</span>-->
<!--                    </div>-->
<!--                    <div class="approvedRight">-->
<!--                        <p>以代理案件:</p>-->
<!--                        <span>0 件</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="agencyBox">-->
<!--                    <p>代理中案件:0</p>-->
<!--                </div>-->
<!--            </div>-->
<!--&lt;!&ndash;            右边&ndash;&gt;-->
<!--            <div class="rightBox">-->
<!--                <div class="messageBox">-->
<!--                    <p>消息</p>-->
<!--                    <span>查看更多</span>-->
<!--                </div>-->
<!--                <div class="message">-->
<!--                    <p>2022-12-01 00:00:01 （2022）萍仲裁字第G786号案开庭笔记待确认，请今天尽快处理。</p>-->
<!--                    <p>2022-12-01 00:00:01 （2022）萍仲裁字第G786号案开庭笔记待确认，请今天尽快处理。</p>-->
<!--                    <p>2022-12-01 00:00:01 （2022）萍仲裁字第G786号案开庭笔记待确认，请今天尽快处理。</p>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>

</template>

<script>
    export default {
        name: 'homePage',
        methods:{
            //发起立案
            toInitiate(){
                this.$router.push('/initiate')
            },
            //导入案件
            skipCase(){
                this.$router.push('/lawCase')
            }
        }
    };
</script>

<style scoped>
    .topBox{
        display: flex;
    }
    .startBox,
    .importBox{
        width: 170px;
        height: 90px;
        border-radius: 20px;
        margin-right: 30px;
        background-image: linear-gradient(to right, #2245b4 , #3f62f4);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        color: #fff;
        cursor: pointer;
    }
    .startBox>p,
    .importBox>p{
        font-size: 26px;
        font-weight: 600;
    }
    .startBox>span,
    .importBox>span{
        font-size: 14px;
    }
    /*数据展示*/
    .displayBox{
        color: #666666;
        overflow: hidden;
        margin-top: 40px;
        display: flex;
    }
    .leftBox{
        width: 50%;
        border: 1px solid #dfdfdf;
        margin-right: 10px;
    }

    .rightBox{
        width: 50%;
        border: 1px solid #dfdfdf;
    }
    .auditBox,
    .approved{
        display: flex;
        margin: 50px 30px;
        width: 80%;
        justify-content: space-between;

    }
    .auditBoxLeft,
    .auditBoxRight,
    .approvedLeft,
    .approvedRight{
        display: flex;
    }
    .agencyBox{
        height: 60px;
        border-top: 1px dashed #dfdfdf;
        line-height: 60px;
    }
    .agencyBox>p{
        margin-left: 30px;
    }
    .messageBox{
        height: 50px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #dfdfdf;
        line-height: 50px;
    }
    .messageBox>p{
        margin-left: 20px;
    }
    .messageBox>span{
        margin-right: 20px;
        cursor: pointer;
    }
    .message>p{
        font-size: 14px;
        margin: 20px;
    }
</style>
